import { Directive, input } from '@angular/core';

/** Supported UL icon size modifiers. */
export type IconSize = 'extra-small' | 'small' | 'medium' | 'large';

/** Supported UL color classes. */
export type IconColor = '' | 'inactive' | 'info' | 'success' | 'danger' | 'warning';

/**
 * Applies UL Design System icon styling to an SVG, `i`, or `ul-icon` element.
 *
 * Use an `i` for a ligature icon, for example `<i comp-icon>more_vert</i>`.
 * The icon is decorative and hidden from assistive technology.
 *
 * Look up the available icons at https://fonts.google.com/icons
 */
@Directive({
  selector: 'svg[comp-icon], i[comp-icon], ul-icon[comp-icon]',
  host: {
    '[class.ul-icon]': '!isPadded()',
    '[class.ul-icon__padded]': 'isPadded()',
    '[class.-extra-small]': "size() === 'extra-small'",
    '[class.-small]': "size() === 'small'",
    '[class.-medium]': "size() === 'medium'",
    '[class.-large]': "size() === 'large'",
    '[class.-inactive]': "color() === 'inactive'",
    '[class.-info]': "color() === 'info'",
    '[class.-success]': "color() === 'success'",
    '[class.-danger]': "color() === 'danger'",
    '[class.-warning]': "color() === 'warning'",
    '[class]': 'customStyling()',
    'aria-hidden': 'true',
  },
})
export class IconDirective {
  /** UL size modifier. Defaults to `small`. */
  size = input<IconSize>('small');

  /** Additional CSS classes applied to the UL icon element. */
  customStyling = input('');

  /** Whether to apply the UL icon padding. Defaults to `false`. */
  isPadded = input<boolean>(false);

  /** UL color modifier. Defaults to `''`. */
  color = input<IconColor>('');
}
